import { useMutation } from "@tanstack/react-query";
import { ordersApi } from "../api/ordersApi";
import { rememberPlacedOrder } from "../lib/placedOrders";

/**
 * Places a guest order and remembers it on this device so the customer can
 * return without the email.
 */
export function useCreateOrder({ custom = false, onSuccess, onError } = {}) {
  return useMutation({
    mutationFn: (data) => (custom ? ordersApi.createCustom(data) : ordersApi.create(data)),
    onSuccess: (order, variables) => {
      rememberPlacedOrder({
        token: order?.access_token,
        orderNumber: order?.order_number,
        kind: custom ? "custom-order" : "order",
        title: variables?.product_title || order?.product_title || "",
      });
      onSuccess?.(order);
    },
    onError,
  });
}
